<template lang="pug">
    v-dialog(v-model="dialog" width="600")
        template(v-slot:activator="{ on, attrs }")
            v-btn.mb-8.mt-8(small v-bind="attrs" v-on="on") {{ label }}
        v-card
            v-card-title Select User
            feathers-vuex-find(service="vw-user-artists-and-labels" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
                v-card-text(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
                    v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search" single-line hide-details)
                    v-data-table(
                        :headers="headers"
                        :loading="isFindPending"
                        :items="isFindPending ? [] : desserts"
                        :options.sync="pagination"
                        :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                        :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
                        loading-text="Fetching Data..."
                    )
                        template(v-slot:item.avatar="{ item }")
                            v-avatar(color="primary" size="32")
                                img(:src="item.profile_picture_thumb")
                        template(v-slot:item.fullname="{ item }") {{ item.artist_name }}
                        template(v-slot:item.select="{ item }")
                            v-btn(small color="primary" @click="selectUser(item)") Select
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: 'Select User'
        }
    },
    data() {
        return {
            dialog: false,
            searchUser: null,
            headers: [
                {
                    text: 'Avatar',
                    align: 'start',
                    sortable: true,
                    value: 'avatar'
                },
                {
                    text: 'Full Name',
                    align: 'start',
                    sortable: true,
                    value: 'fullname'
                },
                {
                    text: '',
                    align: 'end',
                    value: 'select'
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: [],
                sortDesc: []
            }
        };
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { artist_name: { $like: `%${this.searchUser}%` } }
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { artist_name: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } }
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        case 'fullname':
                            $sort.artist_name = this.pagination.sortDesc[index] ? -1 : 1;
                            break;
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
    },
    methods: {
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        selectUser(item) {
            this.$emit('select', item);
            this.dialog = false;
        }
    }
}
</script>